import React, {Component, Fragment} from 'react';
import autobind from "autobind-decorator";
import * as InitStatus from "../../../constants/common/InitializationStatus";
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import classnames from 'classnames'
import {number_format} from "../../../utils/formatter";
import moment from "moment/moment";
import If from "../../common/control/If";
import {addPrefix} from "../../../utils/UriUtil"

class BlogPast extends Component {

  constructor(props) {
    super(props);
    this.yearListRef;
    this.yearLayerRef;
    this.state = {
      monthlyStatus: InitStatus.INIT_READY,
      dailyStatus: InitStatus.INIT_READY,
      yearlyList: [],
      monthlyList: [],
      dailyList: [],
      isOpenWrapper: false,
      isOpenYear: false,
      activeYear: "2017",
      activeMonth: "12",
      createdDate: null
    };
  }

  // Mount후 데이터를 호출한다.
  componentDidMount() {
    this.getYearly();
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  // Unmount전 Mouse event을 clear한다.
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  // 최초 블로그를 개설한 날짜부터 리뉴얼되기전인 2017년까지의 Year을 가져온다.
  getYearly() {
    const {dispatch} = this.props;
    this.setState({monthlyStatus: InitStatus.INIT_DOING}, () => {
      fetch(addPrefix("/manage/statistics/blog/past.json"), {
        credentials: 'include',
        headers: {'Content-Type': 'application/json'}
      })
        .then(jsonResponseHandler(dispatch))
        .then(r => r.json())
        .then(res => {
          const data = res.data;
          this.setState({
            monthlyStatus: InitStatus.INIT_SUCCESS,
            yearlyList: data.list,
            createdDate: data.createdDate,
          });
        })
        .catch(e => {
          console.error(e);
          this.setState({monthlyStatus: InitStatus.INIT_FAIL});
          alert('통계 정보를 조회할 수 없습니다. 잠시 후 다시 시도해 주시기 바랍니다.');
        })
    });
  }


  // 월별 데이터
  getMonthly() {
    const {dispatch} = this.props;
    const {activeYear} = this.state;
    this.setState({monthlyStatus: InitStatus.INIT_DOING}, () => {
      fetch(addPrefix(`/manage/statistics/blog/${activeYear}/past.json`), {
        credentials: 'include',
        headers: {'Content-Type': 'application/json'}
      })
        .then(jsonResponseHandler(dispatch))
        .then(r => r.json())
        .then(res => {
          this.setState({
            monthlyStatus: InitStatus.INIT_SUCCESS,
            monthlyList: res.data
          });
        })
        .catch(e => {
          console.error(e);
          this.setState({monthlyStatus: InitStatus.INIT_FAIL});
          alert('통계 정보를 조회할 수 없습니다. 잠시 후 다시 시도해 주시기 바랍니다.');
        })
    });
  }


  // 월별 데이터
  getDaily() {
    const {dispatch} = this.props;
    const {activeYear, activeMonth} = this.state;
    this.setState({dailyStatus: InitStatus.INIT_DOING}, () => {

      fetch(addPrefix(`/manage/statistics/blog/${activeYear}/${activeMonth}/past.json`), {
        credentials: 'include',
        headers: {'Content-Type': 'application/json'}
      })
        .then(jsonResponseHandler(dispatch))
        .then(r => r.json())
        .then(res => {
          this.setState({
            dailyStatus: InitStatus.INIT_SUCCESS,
            dailyList: res.data
          });
        })
        .catch(e => {
          console.error(e);
          this.setState({dailyStatus: InitStatus.INIT_FAIL});
          alert('통계 정보를 조회할 수 없습니다. 잠시 후 다시 시도해 주시기 바랍니다.');
        })
    });
  }

  // 블로그 개설일보다 이전이거나 null일경우엔 '-' 그외는 숫자 포멧팅
  numberFormatByCreatedDate(number, date) {
    const {createdDate} = this.state;
    const format = "YYYYMMDD";
    if (createdDate != null && date != null && number != null) {
      return (moment(date).format(format) <= moment(createdDate).format(format)) ? '-' : number_format(number);
    }
    return '-';
  }


  @autobind
  handleClickOutside(event) {
    if (this.yearListRef && !this.yearListRef.contains(event.target) && !this.yearLayerRef.contains(event.target)) {
      this.setState({isOpenYear: false});
    }
  }

  @autobind
  changeOpenWrapper() {
    this.setState((prevState) => ({
      isOpenWrapper: !prevState.isOpenWrapper,
      activeYear: "2017",
      activeMonth: "12",
    }), () => {
      if (this.state.isOpenWrapper) {
        this.getMonthly();
        this.getDaily();
      }
    });
  }

  @autobind
  chagneYear(year) {
    this.setState({
      activeYear: year,
      activeMonth: "01",
      isOpenYear: false
    }, () => {
      // active state 변경후 monthly, daily정보 재호출
      this.getMonthly();
      this.getDaily();
    });

  }

  @autobind
  changeOpenYear() {
    this.setState((prevState) => ({
      isOpenYear: !prevState.isOpenYear
    }));
  }


  @autobind
  changeActiveMonth(month) {
    // activeMonth 변경후 daily데이터 호출
    this.setState({activeMonth: month}, () => {
      this.getDaily();
    });

  }

  // 로딩
  renderLoading() {
    return <div className="date_loading">
      <div className="inner_g">
        <span className="ico_blog ico_loading">로딩중입니다.</span>
      </div>
    </div>
  }

  // 년별 렌더링
  renderYearly(yearlyList, activeYear) {
    const list = yearlyList.map((year, index) => (
        <label
          className={classnames({"lab_set": true, "on": activeYear == year})}
          key={index}
          onClick={() => this.chagneYear(year)}
        >
          <input type="radio" name="ccl3" className="inp_set"/>
          <span className="txt_set">{year}년</span>
        </label>
      )
    );

    return <div className="layer_opt" ref={element => (this.yearListRef = element)}>{list}</div>

  }

  // 월별 리스트 렌더링
  renderMonthly(monthList, activeMonth) {
    return monthList.map((item, index) => {
      const lastDateOfMonth = moment(`${this.state.activeYear}${item.month}01`).endOf('month');
      return (<li
          className={classnames({"on": activeMonth == item.month})}
          key={index}
          onClick={() => this.changeActiveMonth(item.month)}
        >
          <a className="link_day">
            <em className="time_g">{parseInt(item.month)}월</em>
            <span className="num_g">{this.numberFormatByCreatedDate(item.count, lastDateOfMonth)}</span>
            <span className="ico_blog"></span>
          </a>
        </li>
      )
    });
  }

  // 일별 리스트 렌더링
  renderDaily(dailyList) {
    return dailyList.map((item, index) => (
      <li className="on" key={index}>
        <em className="time_g">{moment(item.date).format("YY.MM.DD")}</em>
        <span className="num_g">{this.numberFormatByCreatedDate(item.count, item.date)}</span>
      </li>
    ));
  }


  // 전체 렌더링
  renderList() {
    const {yearlyList, monthlyList, dailyList, activeYear, activeMonth, isOpenYear, monthlyStatus, dailyStatus} = this.state;
    const halfDaily = dailyList.slice(0, 15);
    const anotherHalfDaily = dailyList.slice(15, dailyList.length);
    const isMonthlyLoading = monthlyStatus == InitStatus.INIT_DOING;
    const isDailyLoading = dailyStatus == InitStatus.INIT_DOING;

    return <div className="wrap_box">
      <div className="box_month">
        <h4 className="tit_sub screen_out">{activeYear}년 방문수</h4>
        <h1>{isOpenYear}</h1>
        <div
          className={classnames({"opt_set": true, "opt_open": isOpenYear})}
          ref={element => (this.yearLayerRef = element)}
        >
          <button type="button" className="btn_opt" onClick={this.changeOpenYear}>
            {activeYear}년 방문수
            <span className="ico_blog ico_open"></span>
          </button>

          {/*   -----   yearly 리스트 렌더링   ---- */}
          <ol className="list_visitor">{this.renderYearly(yearlyList, activeYear)}</ol>
        </div>

        {/*   -----   monthly 리스트 렌더링   ---- */}
        <If condition={isMonthlyLoading}> {this.renderLoading()}</If>
        <If condition={!isMonthlyLoading}>
          <ol className="list_visitor">{this.renderMonthly(monthlyList, activeMonth)}</ol>
        </If>

      </div>
      <div className="box_day">
        <h4 className="tit_sub">{activeYear}년 {parseInt(activeMonth)}월 일별 방문수</h4>

        {/*   -----   daily 리스트 렌더링   ---- */}
        <If condition={isDailyLoading}> {this.renderLoading()}</If>
        <If condition={!isDailyLoading}>
          <Fragment>
            <ol className="list_visitor">{this.renderDaily(halfDaily)}</ol>
            <ol className="list_visitor"> {this.renderDaily(anotherHalfDaily)}</ol>
          </Fragment>
        </If>
      </div>
    </div>
  }


  render() {
    const {yearlyList, isOpenWrapper} = this.state;
    const labelName = isOpenWrapper ? "접기" : "보기";

    return (
      <Fragment>
        <button className="link_prev" onClick={this.changeOpenWrapper}>2018년 이전 방문통계 {labelName}</button>

        {/*리스트 렌더링*/}
        <If condition={isOpenWrapper}> {this.renderList()}  </If>
      </Fragment>
    )
  }
}

export default BlogPast;
